import { getContentstackImagesForWidths } from '@noths/polaris-client-utils';
import dynamic from 'next/dynamic';

import { HeroBannerProps, TextColorMode } from 'src/components/blocks/HeroBannerBlock';
import { trackImpression } from 'src/tracking/common/banner';
import { ContentBlockRenderer } from '../../../types/Block';
import { ContentstackImage, ContentstackSection } from '../../../types/Contentstack';
import { Transformer } from '../../../types/Transformer';

export interface ContentstackDepartmentHeroBanner extends ContentstackSection {
  background_color: string;
  text_color_mode: TextColorMode;
  image: {
    image_source: ContentstackImage;
    alt_text: string;
  };
  heading: string;
  sub_heading: string;
  tracking_title: string;
}

interface DepartmentHeroBannerSerializedData extends HeroBannerProps {
  trackingTitle: string;
  trackingPosition?: number;
}

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<DepartmentHeroBannerSerializedData, HeroBannerProps> = {
  Component: dynamic<HeroBannerProps>(() =>
    import('src/components/blocks/HeroBannerBlock').then((mod) => mod.HeroBannerBlock),
  ),
  getProps: ({ ...serializedData }) => {
    const { trackingPosition, trackingTitle, ...restOfSerializedData } = serializedData;

    const placementContext = {
      trackingPosition,
      trackingTitle,
    };
    return {
      ...restOfSerializedData,
      onVisible: () => trackImpression(placementContext, 'Hero banner'),
    };
  },
};

export const transformer: Transformer<
  ContentstackDepartmentHeroBanner,
  DepartmentHeroBannerSerializedData,
  HeroBannerProps
> = ({
  _metadata,
  background_color,
  text_color_mode,
  image,
  heading,
  sub_heading,
  tracking_title,
}) => ({
  uid: _metadata.uid,
  renderer,
  serializedData: {
    headingLine1: heading,
    backgroundColor: background_color,
    textColorMode: text_color_mode,
    images: getContentstackImagesForWidths(image.image_source.url, [360, 500, 700, 900, 1132], {
      aspectRatio: '16:9',
    }),
    imageWidth: 360,
    imageHeight: 216,
    imageAlt: image.alt_text,
    subHeading: sub_heading,
    trackingTitle: tracking_title,
  },
});
